var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23 10.546a.76.76 0 0 1 0-1.088l5.5-5.25a.75.75 0 0 1 1.034 1.084l-4.143 3.96H16.25c.416 0 .75.334.75.75 0 .415-.334.75-.75.75H5.621l4.147 3.956a.75.75 0 0 1-1.034 1.084l-5.5-5.25z"
  })));
};
export default SvgArrowLeft;